import { Box, Typography } from '@mui/material';
import { ModalContent } from '../modal-content.component';
import { Modal } from '../modal.component';
import { DesktopMac } from '@mui/icons-material';
import { ModalActions } from '../modal-actions.component';
import { Button } from '../../Button';
import { useIsMobile } from '@uplift/hooks';
import { useToggle } from '../../hooks';
import { UpliftThemeProvider } from '../../theme';

export const SuggestDesktopModal = () => {
  const [ opened, _setOpened, setClosed ] = useToggle(true);
  const isMobile = useIsMobile('sm');

  return (
    <UpliftThemeProvider>
      <Modal
        open={isMobile && opened}
        onClose={setClosed}
        fullWidth
        PaperProps={{
          style: {
            maxWidth: '80%',
          }
        }}
      >
        <ModalContent>
          <Box mb={2} fontSize="40px" textAlign="center">
            <DesktopMac fontSize="inherit" />
          </Box>
          <Typography align="center">
            Complete on desktop for a<br />better experience
          </Typography>
        </ModalContent>
        <ModalActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" color="secondary" onClick={setClosed}>Got it</Button>
        </ModalActions>
      </Modal>
    </UpliftThemeProvider>
  );
};
